var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("alert-modal", {
        ref: "confirm",
        attrs: { cancelable: "", alertText: _vm.alertText },
        on: {
          confirm: _vm.confirmConfirmation,
          cancel: _vm.cancelConfirmation,
        },
      }),
      _vm.showButtonVisible
        ? _c(
            "b-button",
            {
              attrs: { size: "sm", variant: "outline-secondary" },
              on: { click: _vm.show },
            },
            [_vm._v(_vm._s(_vm.config.showButtonHtml))]
          )
        : _vm._e(),
      _c(
        "b-modal",
        {
          ref: "basePictureModal",
          staticClass: "text-sm-left",
          attrs: { id: "basePictureModal", centered: "", "hide-footer": "" },
          on: { hidden: _vm.onHidden, shown: _vm.onShown },
        },
        [
          _c(
            "template",
            { slot: "modal-header" },
            [
              _vm.config.showPicture
                ? _c(
                    "div",
                    { staticClass: "modal-photo-container" },
                    [
                      _c("picture-placeholder", {
                        attrs: {
                          textIn: _vm.config.modalTitle,
                          pictureUrl: _vm.config.pictureUrl,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c("div", { staticClass: "modal-toolbar" }, [
                !_vm.isEditing
                  ? _c("span", { on: { click: _vm.deleteUnitType } }, [
                      _c("i", {
                        staticClass:
                          "delete-unit-type fi-trash nav-icon modal-btn",
                      }),
                    ])
                  : _vm._e(),
                _c("span", { on: { click: _vm.toggleEditMode } }, [
                  _vm.isEditing
                    ? _c("i", {
                        staticClass:
                          "save-unit-type fi-save nav-icon modal-btn",
                      })
                    : _c("i", {
                        staticClass:
                          "edit-unit-type fi-pencil nav-icon modal-btn",
                      }),
                ]),
                _c(
                  "span",
                  { staticClass: "modal-btn", on: { click: _vm.hide } },
                  [_c("i", { staticClass: "fi-x nav-icon" })]
                ),
              ]),
              _c("h4", { staticClass: "modal-title" }, [
                _vm._v(_vm._s(_vm.config.modalTitle)),
              ]),
              _c(
                "b-nav",
                {
                  staticClass: "modal-nav-bar",
                  class: {
                    "modal-nav-bar-no-picture": !!!_vm.config.showPicture,
                  },
                },
                _vm._l(_vm.tabs, function (tab, index) {
                  return _c(
                    "b-nav-item",
                    {
                      key: tab.title,
                      staticClass: "modal-nav-link",
                      class: { navLinkActive: tab.id == _vm.currentActiveTab },
                      on: {
                        click: function ($event) {
                          _vm.currentActiveTab = tab.id
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(tab.title.toUpperCase()))]
                  )
                }),
                1
              ),
            ],
            1
          ),
          "error" == _vm.currentActiveTab
            ? _c("div", [
                _c("div", { staticClass: "tab-load-error" }, [
                  _vm._v("Error in Tab Load"),
                ]),
              ])
            : "details" == _vm.currentActiveTab
            ? _c(
                "div",
                [
                  _c(
                    "info-row",
                    {
                      staticClass: "info-main-row py-1",
                      attrs: {
                        title: _vm.$t("unit_type.name").toLowerCase(),
                        sizing: 4,
                      },
                    },
                    [
                      _c("span", { class: { hidden: _vm.isEditing } }, [
                        _vm._v(_vm._s(_vm.unitType.unit_type_name)),
                      ]),
                      _c("b-form-input", {
                        staticClass: "input-info-field",
                        class: { hidden: !_vm.isEditing },
                        attrs: {
                          id: "unit-type-name",
                          type: "text",
                          state: _vm.unitNameValid,
                          value: _vm.unitType.unit_type_name,
                          placeholder: _vm.$t("unit_type.name_placeholder"),
                          "aria-describedby": "unit-name-feedback",
                        },
                        on: { change: _vm.$v.unitType.unit_type_name.$touch },
                        model: {
                          value: _vm.unitType.unit_type_name,
                          callback: function ($$v) {
                            _vm.$set(_vm.unitType, "unit_type_name", $$v)
                          },
                          expression: "unitType.unit_type_name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "info-row",
                    {
                      staticClass: "info-main-row py-1",
                      attrs: {
                        title: _vm.$t("unit_type.rate").toLowerCase(),
                        sizing: 4,
                      },
                    },
                    [
                      _c("span", { class: { hidden: _vm.isEditing } }, [
                        _vm._v(_vm._s(_vm.unitType.base_rate)),
                      ]),
                      _c("b-form-input", {
                        staticClass: "input-info-field",
                        class: { hidden: !_vm.isEditing },
                        attrs: {
                          id: "unit-type-rate",
                          type: "number",
                          state: _vm.unitRateValid,
                          value: _vm.unitType.base_rate,
                          placeholder: _vm.$t("unit_type.rate_placeholder"),
                          "aria-describedby": "unit-rate-feedback",
                        },
                        on: { change: _vm.$v.unitType.base_rate.$touch },
                        model: {
                          value: _vm.unitType.base_rate,
                          callback: function ($$v) {
                            _vm.$set(_vm.unitType, "base_rate", $$v)
                          },
                          expression: "unitType.base_rate",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "info-row",
                    {
                      staticClass: "info-main-row py-1",
                      attrs: {
                        title: _vm.$t("unit_type.description").toLowerCase(),
                        sizing: 4,
                      },
                    },
                    [
                      _c("span", { class: { hidden: _vm.isEditing } }, [
                        _vm._v(_vm._s(_vm.unitType.unit_type_description)),
                      ]),
                      _c("b-form-input", {
                        staticClass: "input-info-field",
                        class: { hidden: !_vm.isEditing },
                        attrs: {
                          id: "unit-type-description",
                          type: "text",
                          state: _vm.unitDescriptionValid,
                          value: _vm.unitType.unit_description,
                          placeholder: _vm.$t(
                            "unit_type.description_placeholder"
                          ),
                          "aria-describedby": "unit-description-feedback",
                        },
                        on: {
                          change: _vm.$v.unitType.unit_type_description.$touch,
                        },
                        model: {
                          value: _vm.unitType.unit_type_description,
                          callback: function ($$v) {
                            _vm.$set(_vm.unitType, "unit_type_description", $$v)
                          },
                          expression: "unitType.unit_type_description",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
      _vm._t("button"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }